import React, { useState, useEffect, useContext } from "react";

import db from "../../services/query";

import PrintHeader from "./common/PrintHeader";
import PrintBodyTitle from "./common/PrintBodyTitle";
import PrintTable from "./common/PrintTable";
import * as queryString from "querystring";

const FacultiesIncomeList = (props) => {
  const params = queryString.parse(props.location.search);

  let title = "درآمد" + (params.title ? ` ${params.title}` : "");
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];

  const [hlfYearObj, setHlfYearObj] = useState({ name:"" });
  const [data, setData] = useState([]);

  const columns = [
    { path: "id", label: "شماره" },
    { path: "class_desc", label: "نام صنف",    },
    { path: "student_count", label: "تعداد محصل" },
    { path: "payable", label: "قابل پرداخت" },
    { path: "discount", label: "تخفیف" },
    { path: "paid", label: "پرداخت شده" },
    { path: "balance", label: "باقیمانده" },
    { path: "current_overall_balance", label: "مجموع باقیمانده" },
  ];

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    const { fid, hyid } = props.match.params;

    try {
      let query = `students/fees/faculties/${fid}/classes?halfYearId=${hyid}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });

      await db.getAll("dropdowns/halfYears").then(({ data }) => {
        for(const hlfYear of data?.data){
          if(hlfYear.id == hyid){
            setHlfYearObj(hlfYear);
            break;
          }
        }
      });

    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper faculties-income-list-print">
      <PrintHeader
        title={title}
        subtitle={hlfYearObj.name}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
    </main>
  );
};

export default FacultiesIncomeList;
